import type { NumericInput } from "./amount";
import { parseNumeric } from "./amount";

export const getMaxRating = (maxScore?: NumericInput, fallback = 5) => {
  const parsedMax = parseNumeric(maxScore, fallback);
  return parsedMax > 0 ? parsedMax : fallback;
};

export const normalizeRating = (
  rating?: NumericInput,
  maxScore?: NumericInput,
) => {
  const maxRating = getMaxRating(maxScore);
  const parsedRating = parseNumeric(rating, 0);
  const clampedRating = Math.min(Math.max(parsedRating, 0), maxRating);

  return {
    rating: clampedRating,
    maxRating,
    hasRating: clampedRating > 0,
  };
};

export const formatRating = (value: number) =>
  Number.isInteger(value) ? String(value) : value.toFixed(1);

export const formatRatingWithMax = (
  rating?: NumericInput,
  maxScore?: NumericInput,
) => {
  const {
    rating: normalizedRating,
    maxRating,
    hasRating,
  } = normalizeRating(rating, maxScore);

  if (!hasRating) return null;
  return `${formatRating(normalizedRating)}/${maxRating}`;
};

export const hasReviewCount = (value?: NumericInput) =>
  parseNumeric(value, 0) > 0;

export const formatReviewLabel = (reviewCount: number) =>
  `${reviewCount.toLocaleString()} review${reviewCount === 1 ? "" : "s"}`;
